import { useContext } from 'react';
import { RadioGroupContext } from './radio-group-context';
export const useRadioGroup = () => useContext(RadioGroupContext);